/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendScenarioDto } from '../../models/backend-scenario-dto';
import { BackendScenarioRequestDto } from '../../models/backend-scenario-request-dto';

export interface ProjectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body: BackendScenarioRequestDto;
}

export function projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendScenarioDto>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendScenarioDto>;
    }),
  );
}

projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded.PATH = '/api/project_calculations/variants_kits/{id}/';
